import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rnurseryy',
  templateUrl: './rnurseryy.component.html',
  styleUrls: ['./rnurseryy.component.css']
})
export class RnurseryyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
